import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import defaultClasses from './tearsheetPDF.module.css';

var OptionsPDF = function OptionsPDF(props) {
  var _product$configurable;

  var product = props.product,
      disabledValuesMap = props.disabledValuesMap;
  var isConfigurable = (product === null || product === void 0 ? void 0 : product.__typename) === 'ConfigurableProduct';

  var getOptionValues = function getOptionValues(option) {
    var values = option.values;

    if (option.attribute_code === 'hf_finish') {
      var _values, _values$map;

      values = (_values = values) === null || _values === void 0 ? void 0 : (_values$map = _values.map(function (item) {
        var _item$label, _item$label2, _item$label3;

        var start = item === null || item === void 0 ? void 0 : (_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.indexOf('(');
        var end = item === null || item === void 0 ? void 0 : (_item$label2 = item.label) === null || _item$label2 === void 0 ? void 0 : _item$label2.indexOf(')');
        var result = item === null || item === void 0 ? void 0 : (_item$label3 = item.label) === null || _item$label3 === void 0 ? void 0 : _item$label3.substring(start + 1, end);
        return _objectSpread(_objectSpread({}, item), {}, {
          sortValue: result
        });
      })) === null || _values$map === void 0 ? void 0 : _values$map.sort(function (a, b) {
        if (a.sortValue > b.sortValue) {
          return 1;
        }

        if (a.sortValue < b.sortValue) {
          return -1;
        }

        return 0;
      });
    }

    return values.map(function (optionValue) {
      var _disabledValuesMap$ge;

      return (_disabledValuesMap$ge = disabledValuesMap.get(option.attribute_id)) !== null && _disabledValuesMap$ge !== void 0 && _disabledValuesMap$ge.get(optionValue.value_index) ? null : React.createElement("span", {
        key: optionValue.uid
      }, optionValue === null || optionValue === void 0 ? void 0 : optionValue.label);
    });
  };

  return isConfigurable ? React.createElement(React.Fragment, null, React.createElement("h5", {
    className: defaultClasses.bottomBorder
  }, "Options"), React.createElement("div", {
    className: defaultClasses.optionsInfo
  }, product === null || product === void 0 ? void 0 : (_product$configurable = product.configurable_options) === null || _product$configurable === void 0 ? void 0 : _product$configurable.map(function (option) {
    return React.createElement("div", {
      className: defaultClasses.optionList,
      key: option.uid
    }, React.createElement("p", {
      className: defaultClasses.optionLabel
    }, option === null || option === void 0 ? void 0 : option.label), getOptionValues(option));
  }))) : React.createElement(React.Fragment, null);
};

export default OptionsPDF;